<template>
  <v-app-bar
    v-if="$route.meta.hideHeader !== true"
    app
    fixed
    dense
    clipped-left
    color="primary"
  >
    <v-app-bar-nav-icon
      v-if="isLoggedIn"
      @click="toggleMenuDrawer"
    />

    <v-spacer />

    <alert-menu v-if="!$route.meta.isPublic && isLoggedIn" />

    <v-btn
      v-if="$route.meta.isPublic"
    />

    <header-bar-menu v-if="isLoggedIn" />

    <v-btn
      v-if="!isLoggedIn"
      rounded
      text
      small
      class="accent--text mr-3"
      :to="{ name: 'login' }"
    >
      Login
    </v-btn>

    <v-btn
      v-if="!isLoggedIn"
      rounded
      outlined
      class="accent--text"
      :to="{ name: 'request-invite' }"
    >
      Request Invite
    </v-btn>
  </v-app-bar>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderBarMenu from '@/components/HeaderBar/HeaderBarMenu.vue'

import AlertMenu from "../Alert/AlertMenu"

export default {
  components: {
    AlertMenu,
    HeaderBarMenu
  },
  data() {
    return {
      menu: false,
      title: ''
    }
  },
  computed: {
    ...mapGetters([ 'isLoading', 'isLoggedIn' ])
  },
  watch: {
    $route(to) {
      // react to route changes...
      this.title = to.meta.pageTitle
    }
  },
  methods: {
    toggleMenuDrawer() {
      this.$store.commit('toggleMenuDrawer')
    },
  }
}
</script>
